export default __webpack_public_path__ + "static/media/staff.d440f19b.PNG";